"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeachingSubjectSchema = void 0;
const zod_1 = require("zod");
const lingo2_models_1 = require("lingo2-models");
/** Преподаваемые дисциплины (что я преподаю) */
exports.TeachingSubjectSchema = zod_1.z.object({
  subject_id: zod_1.z.number(),
  description: zod_1.z.string(),
  video_url: zod_1.z.string(),
  video_id: zod_1.z.string(),
  /** По-умолчанию: режим выбирается исходя из наличия video_id или video_url */
  video_mode: zod_1.z.nativeEnum(lingo2_models_1.ProfileMediaModeEnum).optional().nullable()
});
